<template>
  <ContainerWrapper>
    <OffersList v-if="cptdDisplayAffiliates" title="Antecipação do salário">
      <BlipayOfferCardContainer v-if="cptdDisplayBlipay" key="BLIPAY" />
    </OffersList>
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import { IncomeSource, Partner } from '@/data/common'
import { isDateGreaterThan, localDate } from '@/helpers/date'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import BlipayOfferCardContainer from '@/containers/loans/payroll-anticipation/offer/affiliates/blipay/BlipayOfferCardContainer.vue'
import { getNoCollateralAffiliates } from '@/helpers/loans/no-collateral/affiliates'
import { isMobile } from '@/helpers/globalFunctions'
export default {
  name: 'PayrollAnticipationOffersListContainer',
  components: {
    BlipayOfferCardContainer,
    ContainerWrapper,
    OffersList,
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
      gtAllProposedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllProposedNoCollateralOffers',
      gtNoCollateralLatestSimulationRequest:
        'products/loans/no-collateral/no-collateral/gtNoCollateralLatestSimulationRequest',
      gtAutoColdOffers:
        'products/loans/auto-equity/cold-offer/gtAutoColdOffers',
      gtAllValidatingAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllValidatingAutoOffers',
      gtAllProposedAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllProposedAutoOffers',
      gtAutoEquityLatestColdOfferRequest:
        'products/loans/auto-equity/cold-offer/gtAutoEquityLatestColdOfferRequest',
      gtFgtsLastSimulationDate: 'products/loans/fgts/gtFgtsLastSimulationDate',
      gtFgtsLatestSimulationRequest:
        'products/loans/fgts/gtFgtsLatestSimulationRequest',
      gtAllOngoingFgtsOffers: 'products/loans/fgts/gtAllOngoingFgtsOffers',
    }),
    cptdDisplayBvFgts() {
      return false // disabled for now
    },
    cptdDisplayUppFgts() {
      return (
        !!this.gtFgtsLastSimulationDate &&
        this.gtFgtsLatestSimulationRequest?.fgts_balance > 50
      )
    },
    cptdNoCollateralAffiliates() {
      if (this.personaData && this.gtCreditScoreLatest?.data?.score) {
        return getNoCollateralAffiliates(
          this.gtAllProposedNoCollateralOffers,
          this.personaData,
          this.gtCreditScoreLatest?.data?.score,
        )
      }
      return {}
    },
    cptdIsAllAffiliatesRejected() {
      return (
        !this.cptdNoCollateralAffiliates[Partner.JBCRED] &&
        !this.cptdNoCollateralAffiliates[Partner.DEUTOP] &&
        !this.cptdNoCollateralAffiliates[Partner.ZIPPI]
      )
    },
    cptdIsRejectedInNoCollateral() {
      return (
        this.gtAllProposedNoCollateralOffers.length === 0 &&
        this.gtNoCollateralLatestSimulationRequest?.created &&
        isDateGreaterThan(
          localDate(this.gtNoCollateralLatestSimulationRequest?.created),
          new Date(Date.now() - 24 * 60 * 60 * 1000 * 30),
        )
      )
    },
    cptdIsCltAndRejectedInFgts() {
      if (this.personaData?.finance?.income_source === IncomeSource.CLT) {
        return (
          !this.cptdDisplayBvFgts &&
          !this.cptdDisplayUppFgts &&
          this.gtAllOngoingFgtsOffers.length === 0
        )
      }

      return false
    },
    cptdHasNoAutoOffers() {
      return (
        this.gtAllProposedAutoOffers.length === 0 &&
        this.gtAllValidatingAutoOffers.length === 0 &&
        this.gtAutoColdOffers.length === 0
      )
    },
    cptdDisplayAffiliates() {
      return this.cptdDisplayBlipay
    },
    cptdDisplayBlipay() {
      const enabled = false
      return (
        enabled &&
        isMobile &&
        this.cptdIsRejectedInNoCollateral &&
        this.cptdIsCltAndRejectedInFgts &&
        this.cptdIsAllAffiliatesRejected &&
        this.cptdHasNoAutoOffers
      )
    },
  },
}
</script>
<style lang="scss"></style>
